/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { ActionableNotification, Button, Link, ModalBody, ModalFooter, ModalHeader } from '@carbon/react';

import { Modal, ModalContent } from 'App/Pages/Diagram/features/deployment/modals/modal-base';
import { defineStagesModalStore } from 'App/Pages/Diagram/Deployment/defineStagesModal';

export default function NoDevClusterSelectedNotification({ isOpen, onClose }) {
  return (
    <Modal open={isOpen} onClose={onClose} preventCloseOnClickOutside>
      <ModalHeader title={'Open Play'} />
      <ModalBody>
        <ModalContent>
          <ActionableNotification
            data-modal-primary-focus
            inline
            actionButtonLabel={'Define stages'}
            onActionButtonClick={() => {
              onClose();
              defineStagesModalStore.open({ executeModalMode: 'play' });
            }}
            kind="warning"
            lowContrast
            hideCloseButton
            title="Development stage not configured"
            subtitle={
              <span>
                To launch Play you need to assign a cluster to the development stage.{' '}
                <Link
                  href="https://docs.camunda.io/docs/next/components/modeler/web-modeler/process-applications/" /* TODO Update the learn more link: https://github.com/camunda/web-modeler/issues/10299 */
                  target="_blank"
                >
                  Learn more
                </Link>
              </span>
            }
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <Button kind="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled>Continue</Button>
      </ModalFooter>
    </Modal>
  );
}
